import { cva } from 'class-variance-authority';
import styles from '../../styles.module.scss';

export const tableFillHeightVariants = cva(undefined, {
  variants: {
    size: {
      sm: styles.sizeSm,
      md: styles.sizeMd,
      lg: styles.sizeLg,
      xl: styles.sizeXl,
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
